import { matchPath, useLocation } from 'react-router-dom';
import PATHS from '../../../routes/routes.const';

export const useIsRachelPage = () => {
  const { pathname } = useLocation();

  return !!matchPath(pathname, { path: PATHS.main.rachel.path, exact: true });
};
